import script from "./error404.vue?vue&type=script&setup=true&name=error404&lang=js"
export * from "./error404.vue?vue&type=script&setup=true&name=error404&lang=js"

const __exports__ = script;

export default __exports__